import React from 'react'
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid'

const TableSearch = ({
  value,
  onChange,
  placeholder = 'Search',
  className = '',
  id = 'table-search',
}) => (
  <label className={`relative block w-full sm:w-64 ${className}`}>
    <span className="sr-only">Search</span>
    <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" />
    <input
      id={id}
      className="nx-input pl-9"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="search"
    />
  </label>
)

export default TableSearch
